import AppConfig from "../../../../../AppConfig";
import BottomActionBar from "../../../../../custom-packages/contextual-action-bar/BottomActionBar";
import {
    ActivityIndicator, CCText,
    TouchableWithoutFeedback, View
} from "../../../../../custom-packages/react-native-components-in-react/react-native-components-in-react";

import './MenuEditorBottomBar.scss'
import BrandIcon from "../../../../../assets/custom-icons/BrandIcon";
import WaiterIcon from "../../../../../assets/custom-icons/WaiterIcon";
import ArtIcon from "../../../../../assets/custom-icons/ArtIcon";
import ChartIcon from "../../../../../assets/custom-icons/ChartIcon";
import {GetAuthObject} from "../../../../../authentication/AuthFunctions";
import {RegisterEvent} from "../../../../../AnalyticsFunctions";
import CheckMarkIcon from "../../../../../assets/custom-icons/CheckMarkIcon";

const TMenuEditorBottomBar = {
    // English
    "enUS": {
        'FOOD': 'Food',
        'HEADER': 'Header',
        'CUSTOMIZE': 'Customize',
        'SURVEY': 'Survey',
        'SAVING_CHANGES': 'Saving Changes',
        'CHANGES_SAVED': 'Changes Saved',
    },
    // Spanish
    "esMX": {
        'FOOD': 'Alimentos',
        'HEADER': 'Cabecera',
        'CUSTOMIZE': 'Apariencia',
        'SURVEY': 'Encuesta',
        'SAVING_CHANGES': 'Guardando Cambios',
        'CHANGES_SAVED': 'Cambios Guardados',
    }
}

const MenuEditorBottomBar = ({menuID, saving = false, saved = false, errorMsg = ''}) => {
    const auth = GetAuthObject();

    return <BottomActionBar
        style={{
            boxShadow: '0 -2px 6px rgba(0, 0, 0, 0.2)',
            borderTop: '1px solid #999999'
        }}
        containerStyle={{
            padding: 0,
            flexDirection: 'column',
        }}
    >
        {
            saving ?
                <View
                    className={'alert alert-info'}
                    style={{
                        margin: 0,
                        borderRadius: 0,
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                >
                    <ActivityIndicator
                        size={20}
                        color={''}
                        style={{
                            marginRight: 10
                        }}
                    />
                    <CCText>
                        {TMenuEditorBottomBar[AppConfig.lang].SAVING_CHANGES}
                    </CCText>
                </View>
                :
                null
        }
        {
            saved ?
                <View
                    className={'alert alert-success'}
                    style={{
                        margin: 0,
                        borderRadius: 0,
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                >
                    <CheckMarkIcon
                        size={20}
                        color={'#0a3622'}
                        style={{
                            marginTop: 6,
                            marginRight: 10
                        }}
                    />
                    <CCText>
                        {TMenuEditorBottomBar[AppConfig.lang].CHANGES_SAVED}
                    </CCText>
                </View>
                :
                null
        }
        {
            errorMsg ?
                <View
                    className={'alert alert-danger'}
                    style={{
                        margin: 0,
                        borderRadius: 0,
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                >
                    <CCText
                        style={{
                            textAlign: 'center'
                        }}
                    >
                        {errorMsg}
                    </CCText>
                </View>
                :
                null
        }
        <View
            style={{
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}
        >
            <TouchableWithoutFeedback
                onPress={() => {
                    RegisterEvent({
                        source: window.location.href,
                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_MENU_CREATOR,
                        token: auth.token,
                        action: 'NAV_EDITOR_CLICK'
                    })
                }}
                to={'/admin/menu/editor/' + menuID}
                style={{
                    fontSize: '1.15rem',
                    padding: '10px 0 5px',
                    width: '25%',
                    textAlign: 'center'
                }}
                className={
                    window.location.pathname.includes('/editor/')
                    ||
                    window.location.pathname.includes('/menu/category/') ?
                        'menu-editor-bottom-bar-selected'
                        :
                        ''
                }
            >
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                >
                    <WaiterIcon
                        width={20}
                        height={20}
                        color={
                            window.location.pathname.includes('/editor/')
                            ||
                            window.location.pathname.includes('/menu/category/') ?
                                'white'
                                :
                                'black'
                        }
                    />
                </View>
                <View
                    style={{
                        fontSize: '1.15rem',
                        textAlign: 'center',
                        marginTop: 5
                    }}
                >
                    {TMenuEditorBottomBar[AppConfig.lang].FOOD}
                </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
                onPress={() => {
                    RegisterEvent({
                        source: window.location.href,
                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_MENU_CREATOR,
                        token: auth.token,
                        action: 'NAV_HEADER_CLICK'
                    })
                }}
                to={'/admin/menu/header/' + menuID}
                style={{
                    fontSize: '1.15rem',
                    padding: '10px 0 5px',
                    width: '25%',
                    textAlign: 'center'
                }}
                className={
                    window.location.pathname.includes('/header/') ?
                        'menu-editor-bottom-bar-selected'
                        :
                        ''
                }
            >
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                >
                    <BrandIcon
                        size={20}
                        color={
                            window.location.pathname.includes('/header/') ?
                                'white'
                                :
                                'black'
                        }
                    />
                </View>
                <View
                    style={{
                        fontSize: '1.15rem',
                        textAlign: 'center',
                        marginTop: 5
                    }}
                >
                    {TMenuEditorBottomBar[AppConfig.lang].HEADER}
                </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
                onPress={() => {
                    RegisterEvent({
                        source: window.location.href,
                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_MENU_CREATOR,
                        token: auth.token,
                        action: 'NAV_CUSTOMIZER_CLICK'
                    })
                }}
                to={'/admin/menu/customizer/' + menuID}
                style={{
                    fontSize: '1.15rem',
                    padding: '10px 0 5px',
                    width: '25%',
                    textAlign: 'center'
                }}
                className={
                    window.location.pathname.includes('/customizer/') ?
                        'menu-editor-bottom-bar-selected'
                        :
                        ''
                }
            >
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                >
                    <ArtIcon
                        size={20}
                        color={
                            window.location.pathname.includes('/customizer/') ?
                                'white'
                                :
                                'black'
                        }
                    />
                </View>
                <View
                    style={{
                        fontSize: '1.15rem',
                        textAlign: 'center',
                        marginTop: 5
                    }}
                >
                    {TMenuEditorBottomBar[AppConfig.lang].CUSTOMIZE}
                </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
                onPress={() => {
                    RegisterEvent({
                        source: window.location.href,
                        sequenceID: AppConfig.ANALYTICS_SEQUENCE_MENU_CREATOR,
                        token: auth.token,
                        action: 'NAV_SURVEY_CLICK'
                    })
                }}
                to={'/admin/menu/survey/' + menuID}
                style={{
                    fontSize: '1.15rem',
                    padding: '10px 0 5px',
                    width: '25%',
                    textAlign: 'center'
                }}
                className={
                    window.location.pathname.includes('/survey/') ?
                        'menu-editor-bottom-bar-selected'
                        :
                        ''
                }
            >
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                >
                    <ChartIcon
                        size={20}
                        color={
                            window.location.pathname.includes('/survey/') ?
                                'white'
                                :
                                'black'
                        }
                    />
                </View>
                <View
                    style={{
                        fontSize: '1.15rem',
                        textAlign: 'center',
                        marginTop: 5
                    }}
                >
                    {TMenuEditorBottomBar[AppConfig.lang].SURVEY}
                </View>
            </TouchableWithoutFeedback>
        </View>
    </BottomActionBar>
}

export default MenuEditorBottomBar;